import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card,
  CardTitle,
  CardText,
  TextField,
  AutoComplete,
  Toggle,
} from 'material-ui';
import { StyleSheet, css } from 'aphrodite';

import DateEntry from './DateEntry';
import * as RateQuoteActions from '../../store/actions/RateQuoteActions';

@connect(state => ({
  destination: state.RateQuote.get('destination'),
  vendorName: state.RateQuote.get('vendorName'),
  vendorURL: state.RateQuote.get('vendorURL'),
  amenityType: state.RateQuote.get('amenityType'),
  roomRates: state.RateQuote.get('roomRates'),
  amenities: state.RateQuote.get('amenities'),
  averageRate: state.RateQuote.get('averageRate'),
}))
export default class RateEntry extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    destination: PropTypes.string,
    vendorName: PropTypes.string,
    vendorURL: PropTypes.string,
    amenityType: PropTypes.string,
    roomRates: PropTypes.string,
    amenities: PropTypes.string,
    averageRate: PropTypes.bool,
  };

  static defaultProps = {
    destination: '',
    vendorName: '',
    vendorURL: '',
    amenityType: '',
    roomRates: '',
    amenities: '',
    averageRate: false,
  };

  updateField = fieldName => e => {
    this.props.dispatch(
      RateQuoteActions.updateString(fieldName, e.target.value),
    );
  };

  handleUpdateInput = fieldName => value => {
    this.props.dispatch(RateQuoteActions.updateString(fieldName, value));
  };

  toggleAverageRate = e => {
    this.props.dispatch(
      RateQuoteActions.updateString('averageRate', e.target.checked),
    );
  };

  autoCompleteFilter = (searchText, key) => {
    const loweredSearchText = searchText.toLowerCase();
    const loweredKey = key.toLowerCase();

    return searchText !== '' && loweredKey.includes(loweredSearchText);
  };

  rateTypes = [
    'Best Available Rate',
    'Virtuoso Best Available Rate',
    'Preferred Partner Best Available Rate',
    'Diamond Club Best Available Rate',
    'Mandarin Oriental Fan Club Best Available Rate',
    'Ritz Carlton STARS Best Available Rate',
    'Starwood Luxury Privileges Best Available Rate',
  ];

  cancellationPresets = [
    '24 hours',
    '48 hours',
    '3 days',
    '7 days',
    '21 days',
    '30 days',
  ];

  depositPresets = [
    'No deposit required;',
    'Deposit required;',
    'One night deposit required at time of booking;',
    'Two night deposit required at time of booking;',
    '50% deposit required at time of booking;',
  ];

  render() {
    const { className } = this.props;

    return (
      <Card className={className}>
        <CardTitle title='Enter Rate Information' />
        <CardText>
          <div className={css(styles.container)}>
            <TextField
              value={this.props.destination}
              floatingLabelText='Destination Name'
              onChange={this.updateField('destination')}
            />
            <DateEntry />
            <div className={css(styles.vendorInfo)}>
              <TextField
                value={this.props.vendorName}
                floatingLabelText='Vendor Name'
                onChange={this.updateField('vendorName')}
              />
              <TextField
                value={this.props.vendorURL}
                floatingLabelText='Vendor URL'
                onChange={this.updateField('vendorURL')}
              />
            </div>
            <AutoComplete
              floatingLabelText='Rate Type'
              dataSource={this.rateTypes}
              onUpdateInput={this.handleUpdateInput('rateType')}
              onNewRequest={this.handleUpdateInput('rateType')}
              fullWidth
              filter={this.autoCompleteFilter}
            />
            <AutoComplete
              floatingLabelText='Deposit/Guarantee'
              dataSource={this.depositPresets}
              onUpdateInput={this.handleUpdateInput('deposit')}
              onNewRequest={this.handleUpdateInput('deposit')}
              fullWidth
              filter={this.autoCompleteFilter}
            />
            <AutoComplete
              floatingLabelText='Cancellation Policy'
              dataSource={this.cancellationPresets.map(
                preset =>
                  `cancel up to ${preset} prior to arrival to avoid penalty.`,
              )}
              onUpdateInput={this.handleUpdateInput('cancellation')}
              onNewRequest={this.handleUpdateInput('cancellation')}
              fullWidth
              filter={this.autoCompleteFilter}
            />
            <Toggle
              checked={this.props.averageRate}
              onClick={this.toggleAverageRate}
              label='Average Nightly Rates'
            />
            <TextField
              floatingLabelText='Room Rates'
              multiLine
              fullWidth
              value={this.props.roomRates}
              onChange={this.updateField('roomRates')}
            />
            <TextField
              floatingLabelText='Amenity Type'
              value={this.props.amenityType}
              onChange={this.updateField('amenityType')}
            />
            <TextField
              floatingLabelText='Amenities'
              multiLine
              fullWidth
              value={this.props.amenities}
              onChange={this.updateField('amenities')}
            />
          </div>
        </CardText>
      </Card>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  vendorInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});



// WEBPACK FOOTER //
// /src/components/RateQuoteGenerator/RateEntry.js